import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';
import Isvg from 'react-inlinesvg';
import { FormattedNumber } from 'react-intl';
import ROUNDED_STAR from 'static/img/icon/star-rounded.svg';

const singleStarRender = ({ rating, stars, count }) => (
  <>
    {rating}
    {stars}
    {count}
  </>
);

const fiveStarRender = ({ rating, stars, count }) => (
  <>
    {rating}
    {stars}
    {count}
  </>
);

fiveStarRender.propTypes = {
  rating: PropTypes.node,
  stars: PropTypes.node,
  count: PropTypes.node,
};

singleStarRender.propTypes = {
  rating: PropTypes.node,
  stars: PropTypes.node,
  count: PropTypes.node,
};

export const StarRating = ({ rating, showRatingNumber, count, className, isDark, singleStar, children }) => {
  let ratingComponent = null;
  if (showRatingNumber && rating > 0) {
    ratingComponent = (
      <span className="ratings__rating ratings--child">
        <FormattedNumber minimumFractionDigits={1} maximumFractionDigits={1} value={rating} />
      </span>
    );
  }

  let starsComponent;
  if (singleStar) {
    starsComponent = (
      <div className="ratings__stars-container ratings--child">
        <Isvg className="ratings__star-icon ratings--star-icon-single" src={ROUNDED_STAR} />
      </div>
    );
  } else {
    starsComponent = (
      <div className="ratings__stars-container ratings--child">
        <div
          className={classNames('ratings__stars-off', {
            'ratings__stars-off--dark': isDark,
          })}>
          <Isvg className="ratings__star-icon" src={ROUNDED_STAR} />
          <Isvg className="ratings__star-icon" src={ROUNDED_STAR} />
          <Isvg className="ratings__star-icon" src={ROUNDED_STAR} />
          <Isvg className="ratings__star-icon" src={ROUNDED_STAR} />
          <Isvg className="ratings__star-icon" src={ROUNDED_STAR} />
        </div>
        <div
          className={classNames('ratings__stars-on', {
            'ratings__stars-on--dark': isDark,
          })}
          style={{ width: `${Math.round(rating * 2) * 10}%` }}>
          <Isvg className="ratings__star-icon" src={ROUNDED_STAR} />
          <Isvg className="ratings__star-icon" src={ROUNDED_STAR} />
          <Isvg className="ratings__star-icon" src={ROUNDED_STAR} />
          <Isvg className="ratings__star-icon" src={ROUNDED_STAR} />
          <Isvg className="ratings__star-icon" src={ROUNDED_STAR} />
        </div>
      </div>
    );
  }

  let countComponent = null;
  if (parseInt(String(count).replace(/[^\d]/g, ''), 10) > 0) {
    countComponent = (
      <span className="ratings__count ratings--child">
        ({typeof count === 'number' ? <FormattedNumber value={count} /> : count})
      </span>
    );
  }

  let render;
  if (typeof children === 'function') {
    render = children;
  } else if (singleStar) {
    render = singleStarRender;
  } else {
    render = fiveStarRender;
  }

  return (
    <div className={classNames('ratings ratings--display', className)}>
      {render({ rating: ratingComponent, stars: starsComponent, count: countComponent })}
    </div>
  );
};

StarRating.propTypes = {
  rating: PropTypes.number.isRequired,
  className: PropTypes.string,
  isDark: PropTypes.bool,
  showRatingNumber: PropTypes.bool,
  count: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  singleStar: PropTypes.bool,
  children: PropTypes.func,
};

StarRating.defaultProps = {
  isDark: false,
};
